import { Input } from '@/components/Input';
import { selectAcn } from '@/context/borrower';
import { useAppSelector } from '@/context/storeHooks';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'Acn';

export function Acn({ baseId, showErrors }: IProps): JSX.Element {
    // ***** Redux *****
    const currentState = useAppSelector(selectAcn);

    // ***** Render *****
    return (
        <div data-testid={testId} className='w-full'>
            <Input
                title='ACN'
                placeholder='123 456 789'
                showErrors={showErrors && !currentState}
                id={`${baseId}-input-acn`}
                value={currentState ?? ''}
                disabled
                tooltipContent='Your nine-digit company number. We fill this from your ABN where we can.'
            />
        </div>
    );
}
